import {
  Box,
  Divider,
  styled,
  Tabs,
  Tab,
  Typography,
  AppBar,
} from "@mui/material";
import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import WorkflowHeaderData from "./WorkflowHeaderData";
import DataProcessor from "./dataprocessor/DataProcessor";

const EachWorkflowContainer = styled(Box)(({ openDrawer }) => ({
  marginLeft: openDrawer ? 240 : 80,
  width: openDrawer ? "calc(100% - 255px)" : "calc(100% - 85px)",
  // border: openDrawer ? '2px solid green' : '2px solid blue',
  height: "calc(100vh - 70px)",
  display: "flex",
  position: "absolute",
  flexDirection: "column",
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const EachWorkflow = ({ openDrawer, userData }) => {
  const params = useParams();
  const location = useLocation();
  const theme = useTheme();
  const [tabvalue, setTabvalue] = useState(0);

  const headerData = {
    firstHeaderText: location.state?.workflow_name,
    secondHeaderText:
      location.state?.workflow_data.engagement.clientEntity.domainEntity
        .domainName,
    thirdHeaderText: location.state?.client_name,
    fourthHeaderText: location.state?.engagement_name,
    fifthHeaderText: location.state?.created_by,
    sixthHeaderText: location.state?.created_at,
    seventhHeaderText: location.state?.status,
    domainName: "domainName",
    route: `/dep/workflow/${params.engagementId}/${params.processType}`,
  };

  const handleTabChange = (event, newValue) => {
    event.preventDefault();
    setTabvalue(newValue);
  };

  return (
    <EachWorkflowContainer openDrawer={openDrawer}>
      <WorkflowHeaderData data={headerData} />
      <Divider style={{ margin: "20px 0px" }} />
      <Box sx={{ bgcolor: "background.paper", margin: "0px 10px" }}>
        <AppBar position="static">
          <Tabs
            value={tabvalue}
            onChange={handleTabChange}
            indicatorColor="white"
            textColor="white"
            variant="fullWidth"
            aria-label="full width tabs example"
            sx={{
              color: "#fff",
              "& button": { backgroundColor: "#f5f5f5", color: "black" },
              "& button:focus": { color: "white", backgroundImage: "#43425D" },
              "& button.Mui-selected": {
                color: "white",
                backgroundImage: "linear-gradient(to right, #4880EC, #019CAD)",
              },
            }}
          >
            <Tab label="Data Processor" {...a11yProps(1)} />
          </Tabs>
        </AppBar>

        <TabPanel value={tabvalue} index={0} dir={theme.direction}>
          <DataProcessor
            workflow={location.state?.workflow_data}
            userData={userData}
            engagementId={params.engagementId}
            processType={params.processType}
          />
        </TabPanel>
      </Box>
    </EachWorkflowContainer>
  );
};

export default EachWorkflow;
